<template>
  <div class="lib__form__main">
    <ValidationObserver ref="validator" tag="div" class="lib__form__main__content">
      <header class="lib__form__main__header">
        <h2 class="lib__h2" v-html="$t('complaint.newOrTrackingStep.title')"></h2>
      </header>
      <ValidationProvider rules="required" slim v-slot="{ errors, passed, failed }">
        <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class="lib__field">
          <div class="lib__tiles lib__tiles--inline">
              <TileRadio
                item="new"
                key="new"
                :label="$t('complaint.newOrTrackingStep.new')"
                group="newOrTracking"
                v-model="newOrTracking"
              >
              </TileRadio>
              <TileRadio
                item="tracking"
                key="tracking"
                :label="$t('complaint.newOrTrackingStep.tracking')"
                group="newOrTracking"
                v-model="newOrTracking"
              >
              </TileRadio>
          </div>
          <error-message :error="errors[0]"></error-message>
        </div>
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template> 

<script lang="ts">
import { Component, Prop, Watch } from 'vue-property-decorator'
import Step from '../Step'
import { Mutation, State } from 'vuex-class'
import { helper } from '@/services'

@Component
export default class NewOrTrackingStep extends Step {
  //#region [Property]
  @Prop({ required: true, type: String }) public value!: string
  //#endregion

  //#region [Data]
  @State('requestId', { namespace: 'complaint' })
  public readonly requestId!: string
  @State('newOrTracking', { namespace: 'complaint/newOrTracking' })
  public readonly newOrTrackingState!: string

  public newOrTracking: string | null = null
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'complaint/newOrTracking' })
  private store!: (index: string | null) => void
  //#endregion

  //#region [Method]
  public mounted() {
    this.newOrTracking = helper.clone(this.newOrTrackingState)
  }

  public async save(next: boolean, isValid: boolean) {
    if (next && isValid) {
      this.$appInsights.trackEvent('Complaint_StepNewOrTracking_Validated', {
        Segment: 'Complaint',
        WebRef: this.requestId,
      })
    }

    this.store(this.newOrTracking)
  }
  //#endregion

  //#region [Watch]
  @Watch('newOrTracking')
  public onNewOrTrackingChanged() {
    this.$emit('input', this.newOrTracking)
  }
  //#endregion
}
</script>